import { CalendarClock } from "lucide-react";

import { useCurrency } from "@/context/CurrencyContext";

export default function ReservationsReportPanel({ reservations }) {
  const { formatAmount } = useCurrency();
  const summary = reservations || { cantidad: 0, monto_total: 0, detalle: [] };

  return (
    <section className="reservations-report-panel" data-testid="reservations-report-panel">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">RESERVAS ACTIVAS</span>
          <h2>Montos comprometidos</h2>
        </div>
        <CalendarClock size={21} />
      </div>
      <div className="reservation-report-summary">
        <span><strong data-testid="active-reservations-count">{summary.cantidad}</strong> reservas activas</span>
        <span data-testid="active-reservations-amount">{formatAmount(summary.monto_total)}</span>
      </div>
      {summary.detalle.length ? <div className="reservation-report-list">{summary.detalle.map((item) => <div data-testid={`report-reservation-${item.id}`} key={item.id}><span><strong>{item.lot.manzano} · {item.lot.lote}</strong><small>{item.client_name} · vence {item.fecha_vencimiento}</small></span><b>{formatAmount(item.monto_reserva)}</b></div>)}</div> : <p className="empty-inline">No hay reservas activas en este periodo.</p>}
    </section>
  );
}
